/* src/modules/lessons/actions.js */

import {
  fetchLessonsTypes,
  fetchLessonTypes,
  fetchUserLessonTypes,
  refundLessonTypes,
  SET_LESSON_PAGE,
  SET_LESSON_PAGE_COUNT,
} from './action_types';

import { makeQuery, makeMutation } from '../../config/client';
import {
  FETCH_LESSONS_QUERY,
  FETCH_LESSON_QUERY,
  FETCH_USER_LESSON_QUERY,
  REFUND_LESSON_MUTATION,
} from './api';

export const fetchLessons = variables => makeQuery(variables)(
  fetchLessonsTypes,
  FETCH_LESSONS_QUERY
);

export const fetchLesson = variables => makeQuery(variables)(
  fetchLessonTypes,
  FETCH_LESSON_QUERY
);

export const fetchUserLesson = variables => makeQuery(variables)(
  fetchUserLessonTypes,
  FETCH_USER_LESSON_QUERY
);

export const refundLesson = variables => makeMutation({ variables })(
  refundLessonTypes,
  REFUND_LESSON_MUTATION
);

export const setLessonPage = payload => ({ type: SET_LESSON_PAGE, payload });

export const setLessonPageCount = payload => ({ type: SET_LESSON_PAGE_COUNT, payload });



// WEBPACK FOOTER //
// ./src/modules/lessons/actions.js